import { alertsWidget } from "./alerts/AlertsWidget";
import { calendarWidget } from "./calendar/CalendarWidget";
import { clockWidget } from "./clock/ClockWidget";
import { choresWidget } from "./family/ChoresWidget";
import { routinesWidget } from "./family/RoutinesWidget";
import { auroraWidget } from "./sky/AuroraWidget";
import { hourlyGraphWidget } from "./sky/HourlyGraphWidget";
import { moonWidget } from "./sky/MoonWidget";
import { nightSkyWidget } from "./sky/NightSkyWidget";
import { quakesWidget } from "./sky/QuakesWidget";
import { sunWidget } from "./sky/SunWidget";
import { uvWidget } from "./sky/UvWidget";
import { converterWidget } from "./kitchen/ConverterWidget";
import { listsWidget } from "./kitchen/ListsWidget";
import { mealsWidget } from "./kitchen/MealsWidget";
import { timersWidget } from "./kitchen/TimersWidget";
import { seasonWidget } from "./kitchen/SeasonWidget";
import { countdownsWidget } from "./home/CountdownsWidget";
import { nightlyWidget } from "./home/NightlyWidget";
import { notesWidget } from "./home/NotesWidget";
import { tomorrowWidget } from "./home/TomorrowWidget";
import { weekSummaryWidget } from "./home/WeekSummaryWidget";
import { fireDangerWidget } from "./outdoors/FireDangerWidget";
import { outThereWidget } from "./outdoors/OutThereWidget";
import { riversWidget } from "./outdoors/RiversWidget";
import { f1Widget } from "./news/F1Widget";
import { newsHeroWidget } from "./news/NewsHeroWidget";
import { newsListWidget } from "./news/NewsListWidget";
import { teamWidget } from "./news/TeamWidget";
import { mountainsWidget } from "./outdoors/MountainsWidget";
import { spotsWidget } from "./outdoors/SpotsWidget";
import { trailMapWidget } from "./outdoors/TrailMapWidget";
import { photoDayWidget } from "./photos/PhotoDayWidget";
import { photoFrameWidget } from "./photos/PhotoFrameWidget";
import { radarWidget } from "./radar/RadarWidget";
import { tasksWidget } from "./tasks/TasksWidget";
import { tickerWidget } from "./ticker/TickerWidget";
import type { WidgetDefinition } from "./types";
import { upcomingWidget } from "./upcoming/UpcomingWidget";
import { airQualityWidget } from "./weather/AirQualityWidget";
import { conditionsDetailWidget } from "./weather/ConditionsDetailWidget";
import { discussionWidget } from "./weather/DiscussionWidget";
import { forecastGraphsWidget } from "./weather/ForecastGraphsWidget";
import { outlookWidget } from "./weather/OutlookWidget";
import { weatherWidget } from "./weather/WeatherWidget";

// The registry of built-in widgets. Adding a widget = writing a definition
// module and listing it here.
const ALL = [
  clockWidget,
  tickerWidget,
  calendarWidget,
  upcomingWidget,
  weatherWidget,
  alertsWidget,
  radarWidget,
  forecastGraphsWidget,
  conditionsDetailWidget,
  outlookWidget,
  discussionWidget,
  airQualityWidget,
  hourlyGraphWidget,
  sunWidget,
  moonWidget,
  nightSkyWidget,
  auroraWidget,
  uvWidget,
  quakesWidget,
  trailMapWidget,
  outThereWidget,
  fireDangerWidget,
  riversWidget,
  spotsWidget,
  mountainsWidget,
  newsHeroWidget,
  newsListWidget,
  f1Widget,
  teamWidget,
  choresWidget,
  routinesWidget,
  tasksWidget,
  notesWidget,
  countdownsWidget,
  nightlyWidget,
  tomorrowWidget,
  weekSummaryWidget,
  seasonWidget,
  mealsWidget,
  listsWidget,
  timersWidget,
  converterWidget,
  photoFrameWidget,
  photoDayWidget,
] as unknown as WidgetDefinition[];

const BY_TYPE = new Map(ALL.map((w) => [w.type, w]));

export function getWidget(type: string): WidgetDefinition | undefined {
  return BY_TYPE.get(type);
}

export function listWidgets(): WidgetDefinition[] {
  return ALL;
}
